import {
  TableContainer,
  Table as MuiTable,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
  Box,
  TablePagination,
  Typography,
  Stack,
  CircularProgress,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { RenderTableRow } from 'src/utils/renderTableRow';
import PropTypes from 'prop-types';

export const Table = ({ name, rows = [], header, hasCheckbox, paginate = {}, actions, isLoading }) => {
  const { page, rowsPerPage, count, onPageChange, onRowsPerPageChange, scrollable } = paginate;
  const { order, orderBy } = paginate;
  const emptyRows = page >= 0 && count > 0 ? Math.max(0, (1 + page) * rowsPerPage - count) : 0;
  const { handleRequestSort } = actions;

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
  }
  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };
  return (
    <>
      <TableContainer>
        <MuiTable sx={{ minWidth: 750 }} size="medium">
          <TableHead>
            <TableRow>
              {header.map((headCell, index) => {
                return (
                  <TableCell
                    key={index}
                    align={headCell.align || 'center'}
                    sortDirection={orderBy === headCell.name?.toLowerCase() ? order : 'asc'}
                  >
                    <TableSortLabel
                      active={orderBy === headCell.name?.toLowerCase()}
                      direction={orderBy === headCell.name ? order : 'asc'}
                      onClick={createSortHandler(headCell.name)}
                    >
                      {headCell.label}
                      {orderBy === headCell.name ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          {count !== 0 && (
            <TableBody>
              {isLoading ? (
                <TableRow sx={{ height: 550 }}>
                  <TableCell>
                    <Box
                      sx={{
                        position: 'relative',
                        left: '50rem',
                      }}
                    >
                      <CircularProgress size={100} />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                stableSort(rows, getComparator(order, orderBy))?.map((row, index) => {
                  return RenderTableRow(name, row, index, actions, hasCheckbox);
                })
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          )}
        </MuiTable>
      </TableContainer>
      {!isLoading && count === 0 && (
        <Stack
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            my: 7,
          }}
        >
          {/* <NoItemIllustration /> */}
          <Typography variant="body1" sx={{ my: 5 }}>
            موردی یافت نشد
          </Typography>
        </Stack>
      )}
      {!scrollable && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};

Table.propTypes = {
  name: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  header: PropTypes.array.isRequired,
  hasCheckbox: PropTypes.bool,
  paginate: PropTypes.object,
  actions: PropTypes.object,
  isLoading: PropTypes.bool,
};

export { Toolbar } from './Toolbar';
export { TableMoreMenu } from './TableMoreMenu';
